(function($) {

	var temp = {};

	if ($('.jq-listing-stage').length) {

		initListingStage();

		$(window).on('resize', initListingStage);

	}

	function initListingStage() {

		$('.jq-listing-stage').each(function(stageIndex, stageElement) {

			initListingScroll($(stageElement));

		});

	}

	function initListingScroll($stage) {

		var stageElement = $stage[0];

		var $el = {};

		$el.stage = $stage;

		$el.scrollBar = $el.stage.next('.jq-listing-scrollbar');

		$el.navigation = $el.stage.prev('.jq-listing-navigation');

		$el.buttons = $('.jq-listing-button', $el.navigation);

		if ($el.scrollBar.length === 0) {

			$el.scrollBar = $el.stage
				.after('<div class="jq-listing-scrollbar"></div>')
				.next('.jq-listing-scrollbar');

		}

		$el.stage
			.removeClass('is-overflowing')
			.css('--listing-container-margin', 0)
			.off('scroll.listing');

		$el.scrollBar
			.hide()
			.css('--listing-stage-width', 0)
			.off('scroll.listing');

		$el.navigation
			.hide();

		if (stageElement.scrollWidth > stageElement.clientWidth) {

			var stageElementMargin = (window.innerWidth - stageElement.clientWidth) / 2;

			var scrollRatio = window.innerWidth / stageElement.clientWidth;

			$el.stage
				.addClass('is-overflowing')
				.css('--listing-container-margin', stageElementMargin + 'px')
				.on('scroll.listing', function() {
					onListingScroll($el.stage, $el.scrollBar, $el.buttons, scrollRatio);
				});

			$el.scrollBar
				.show()
				.css('--listing-stage-width', stageElement.scrollWidth / scrollRatio + 'px')
				.on('scroll.listing', function() {
					onListingScroll($el.scrollBar, $el.stage, $el.buttons, scrollRatio);
				});

			$el.navigation
				.show();

			initListingButtons($el.buttons, $el.stage);

		}

	}

	function onListingScroll($currentElement, $targetElement, $buttons, scrollRatio) {

		clearTimeout(temp.onListingScrollStop);

		var isScrollBar = $currentElement.hasClass('jq-listing-scrollbar');

		$targetElement
			.off('scroll.listing')
			.scrollLeft(function() {
				if (!isScrollBar) {
					return $currentElement.scrollLeft() / scrollRatio;
				} else {
					return $currentElement.scrollLeft() * scrollRatio;
				}
			});

		if (isScrollBar) {

			stateListingButtons($buttons, $targetElement);

		} else {

			stateListingButtons($buttons, $currentElement);

		}

		temp.onListingScrollStop = setTimeout(function() {

			$targetElement.on('scroll.listing', function() {

				onListingScroll($targetElement, $currentElement, $buttons, scrollRatio);
			});

		}, 500);

	}

	function initListingButtons($buttons, $stage) {

		stateListingButtons($buttons, $stage);

		$buttons.on('click', function() {

			var $button = $(this);

			var $nodes = $stage.find('> div > div');

			var direction = $button.data('navigation-direction') || 'next';

			var stageCurrentScroll = $stage.scrollLeft();

			var nodeWidth = Math.ceil($nodes.eq(0).width());

			$stage
				.scrollLeft(function() {
					if (direction == 'next') {
						return stageCurrentScroll + nodeWidth;
					} else {
						return stageCurrentScroll - nodeWidth;
					}
				});

		});

	}

	function stateListingButtons($buttons, $stage) {

		var stageElement = $stage[0];

		var stageCurrentScroll = $stage.scrollLeft();

		if (stageCurrentScroll <= 10) { // intentionally more than 0

			$buttons
				.removeAttr('disabled')
				.filter('[data-navigation-direction="prev"]')
				.attr('disabled', 'disabled');

		} else if (stageCurrentScroll >= stageElement.scrollWidth - stageElement.clientWidth - 10) {

			$buttons
				.removeAttr('disabled')
				.filter('[data-navigation-direction="next"]')
				.attr('disabled', 'disabled');

		} else {

			$buttons
				.removeAttr('disabled')

		}

	}

})(jQuery);
